'use client';

import FsLightbox from 'fslightbox-react';
import { Fragment, useState } from 'react';
import { Row, Col } from 'react-bootstrap';

import { useTranslations } from 'next-intl';

import { MovieDetails, type Snapshot } from '@/api/types/movie.types';

import { ResultNotFound } from '@/components/ResultNotFound';

import { MovieDetailsLayout } from '@/views/MovieDetailsView/MovieDetailsLayout';
import { SnapshotCard } from '@/views/MovieDetailsView/MovieDetailsSnapshotsView/SnapshotCard';
import { HeaderSection } from '@/views/MovieDetailsView/components/HeaderSection';

// =================================================================

interface MovieDetailsSnapshotsProps {
  snapshots: Snapshot[];
  details: MovieDetails;
}

// =================================================================

export const MovieDetailsSnapshotsView = (props: MovieDetailsSnapshotsProps) => {
  const { snapshots, details } = props;

  const t = useTranslations('page.movieDetail');

  const [isLightBoxOpen, setIsLightBoxOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleImageClick = (imageIndex: number) => {
    setIsLightBoxOpen(state => !state);
    setCurrentSlide(imageIndex + 1);
  };

  return (
    <Fragment>
      <MovieDetailsLayout movieTitle={details?.title}>
        <HeaderSection title={t('snapshots')} genre={details.genres[0]} />
        {snapshots.length > 0 && (
          <Row as="ul" xl={4} lg={3} md={2} sm={2} xs={1}>
            {snapshots.map((item, index) => (
              <Col key={item.id} as="li" className="mb-4">
                <SnapshotCard src={item.snapshot} onClick={() => handleImageClick(index)} />
              </Col>
            ))}
          </Row>
        )}
        {snapshots.length === 0 && <ResultNotFound />}
      </MovieDetailsLayout>
      <FsLightbox
        key={JSON.stringify(snapshots)}
        toggler={isLightBoxOpen}
        sources={snapshots.map(item => item.snapshot)}
        slide={currentSlide}
        type="image"
      />
    </Fragment>
  );
};
